var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioScenarioEditor", {
        attrs: { viewModel: _vm.portfolioScenarioEditor },
      }),
      _vm._v(" "),
      _c("SelectorDialog", { attrs: { viewModel: _vm.selectorDialog } }),
      _vm._v(" "),
      _c("div", { staticClass: "text-right align-self-end" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success",
            staticStyle: { padding: "0.7em 1em" },
            attrs: { type: "button", title: "Open Selector (AI Assistant)" },
            on: { click: _vm.showSelectorDialog },
          },
          [
            _c("i", { staticClass: "fa-solid fa-robot fa-lg mr-1" }),
            _vm._v(" Selector\n        "),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/portfolio-plan/projects/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/portfolio-plan/projects/${workspaceId}/${tchProjectId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("projects"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Project Settings" },
            },
            [_c("i", { staticClass: "fa-solid fa-table fa-lg" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/portfolio-plan/selection/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/portfolio-plan/selection/${workspaceId}/${tchProjectId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("selection"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Project Selection" },
            },
            [_c("i", { staticClass: "fa-solid fa-list-check fa-lg" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/portfolio-plan/schedule/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/portfolio-plan/schedule/${workspaceId}/${tchProjectId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("schedule"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Project Schedule" },
            },
            [_c("i", { staticClass: "fa-regular fa-calendar fa-lg" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/portfolio-plan/review/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/portfolio-plan/review/${workspaceId}/${tchProjectId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("review"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Project Review" },
            },
            [_c("i", { staticClass: "fa-solid fa-database fa-lg" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/portfolio-plan/approval/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                  expression:
                    "`/#/portfolio-plan/approval/${workspaceId}/${tchProjectId}/${scenarioId}`",
                },
              ],
              class: _vm.getButtonClass("approval"),
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Project Approval" },
            },
            [_c("i", { staticClass: "fa-solid fa-pen-nib fa-lg" })]
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "sanitizedHref",
                rawName: "v-sanitizedHref",
                value: `/#/portfolio-plan/pnl/${_vm.workspaceId}/${_vm.tchProjectId}/${_vm.scenarioId}`,
                expression:
                  "`/#/portfolio-plan/pnl/${workspaceId}/${tchProjectId}/${scenarioId}`",
              },
            ],
            class: _vm.getButtonClass("pnl"),
            staticStyle: { padding: "0.7em 2em" },
            attrs: { title: "Profit & Loss Report" },
          },
          [_vm._v("\n            P&L\n        ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-secondary",
            staticStyle: { padding: "0.7em 1em" },
            attrs: { title: "Portfolio Plan Settings" },
            on: { click: _vm.showScenarioEditor },
          },
          [_c("i", { staticClass: "fa fa-lg fa-cog" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: _vm.corporateScenarioUrl,
                  expression: "corporateScenarioUrl",
                },
              ],
              staticClass: "btn btn-outline-secondary",
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Enterprise Plan" },
            },
            [_c("i", { staticClass: "fa-solid fa-sitemap fa-lg" })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "sanitizedHref",
                  rawName: "v-sanitizedHref",
                  value: `/#/portfolio-plans/${_vm.workspaceId}/${_vm.tchProjectId}`,
                  expression:
                    "`/#/portfolio-plans/${workspaceId}/${tchProjectId}`",
                },
              ],
              staticClass: "btn btn-outline-secondary",
              staticStyle: { padding: "0.7em 1em" },
              attrs: { title: "Back to Portfolio Plans" },
            },
            [_c("i", { staticClass: "fa-solid fa-door-open fa-lg" })]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }